import styles from './DialogBackdrop.module.scss';
import React from 'react';
import { useDialogContext } from '../DialogContext.ts';
export function DialogBackdrop({ containerRef }) {
    const { onClose } = useDialogContext();
    return /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        className: styles.backdrop,
        onClick: onClose
    });
}
